'use client'
import { Skeleton } from '@morpho-org/ui-v6/server'
import { memo } from 'react'

const MarketSimpleActionPanelLoading = () => {
  return (
    <div className="gap-sm flex grow basis-[100%] flex-col">
      <div className="gap-2xs flex flex-row">
        <Skeleton className="h-lg w-[62px] rounded-[20px]" />
        <Skeleton className="h-lg w-[66px] rounded-[20px]" />
      </div>
      <Skeleton className="h-[144px] w-[100%] rounded-[20px]" />
      <Skeleton className="h-[144px] w-[100%] rounded-[20px]" />
      <Skeleton className="h-[226px] w-[100%] rounded-[20px]" />
      <Skeleton className="h-[48px] w-[100%] rounded-[20px]" />
    </div>
  )
}

export default memo(MarketSimpleActionPanelLoading)
